//接口管理
import http from '../utils/request';

//官网api
let api = {
  // 获取公共的分享内容
  // getShareInfo:() => http.get(`mini/system/globalsetting`),
  // 获取分享的设置参数
  getShareParam:(data) => http.post(`wechat/signature`,data)
}

export default api



// WEBPACK FOOTER //
// ./src/api/api.js